// `beforeunload` handler that shows the browser's leave-page prompt while a client-driven loop a
// page unload would abandon is running. One owner attaches and detaches it: a shared listener
// identity de-duplicates in the DOM, so concurrent owners on one page would clobber each other's
// registration — not a concern for the current single-owner uses (upload, domain refresh).
export function promptBeforeUnload(event: BeforeUnloadEvent) {
    // `returnValue` is the legacy prompt trigger, kept alongside preventDefault() for engines
    // that ignore the latter (e.g. Chrome/Edge < 119). It must be truthy: the conventional
    // `= ''` is inert, since the spec shows the prompt only when returnValue is non-empty.
    event.preventDefault();
    event.returnValue = true;
}
